import React from 'react';
import Area83 from 'views/Area83';


const MathClubPage = () => {
  return <Area83/>;
};

export default MathClubPage;

